require('../common_imports');

translations = JSON.parse(Base64.decode(translations_json));
import { Dropzone } from "dropzone";
window.Dropzone = Dropzone;

require('../common_functions');

require('./register');
require('./login');
require('./contact_us');
require('./password_reset');

require('./custom');

// Vue calculator
require('../calculator/vue');

